import axios from "axios";
import { API_URL } from "./utils";
import { message } from "antd";
import { responseDataFormate } from "./bycrypt";
import AWS from "aws-sdk";
import { v4 as uuidv4 } from "uuid";

const s3 = new AWS.S3({
  accessKeyId: process.env.REACT_APP_CONTABO_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_CONTABO_SECRET_ACCESS_KEY,
  endpoint: process.env.REACT_APP_CONTABO_ENDPOINT,
  s3ForcePathStyle: true,
});

export const CustomFileUploader = async (data: any, folderpath: string) => {
  try {
    const APK_API_URL = `${API_URL}/`;
    const response = await axios.post(`${APK_API_URL}file-upload?uploadDirector=${folderpath}`, data, {
      withCredentials: true,
    });
    const decryptedData = responseDataFormate(response.data);
    return decryptedData?.data?.uploadedFiles; // Return the response data
  } catch (error: any) {
    message.error(error.response?.data?.message || error.message);
    return null; // Return null in case of error
  }
};

export const makeid = (length: number) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
export const CustomFileUploaderNew = async (fileList: any[], folderPath: string) => {
  const uploadedFiles: any[] = [];

  for (const file of fileList) {
    const fileExt = file.name.split(".").pop();
    const ren_string = makeid(32);
    const timestamp = new Date().getUTCMilliseconds();
    const fileName = `${folderPath}/${ren_string}-${timestamp}-${file.name}`;

    const params = {
      Bucket: process.env.REACT_APP_CONTABO_BUCKET,
      Key: fileName,
      Body: file,
      ACL: "public-read",
      ContentType: file.type || "application/octet-stream",
    };

    try {
      const result = await s3.upload(params).promise();

      uploadedFiles.push({
        path: result.Key,
        url: result.Location,
      });
    } catch (error) {
      console.error("Upload to Contabo failed:", error);
      return null;
    }
  }

  return uploadedFiles;
};

export const CustomFileDeleter = async (data: unknown) => {
  try {
    const response = await axios.delete(`${API_URL}/file-upload`, {
      data,
      withCredentials: true,
    });
    return response.data;
  } catch (error: any) {
    message.error(error.response?.data?.message || error.message);
    return null;
  }
};

export const CustomFileDeleterMultiple = async (filePaths: any) => {
  const params = {
    Bucket: process.env.REACT_APP_CONTABO_BUCKET!,
    Delete: {
      Objects: filePaths.map((path:any) => ({ Key: path })), // Map each path into { Key }
      Quiet: false, // Optional: false means S3 will return deleted file list
    },
  };

  try {
    const result = await s3.deleteObjects(params).promise();
   
    if (result.Errors?.length) {
      console.warn(`⚠️ Some files could not be deleted:`, result.Errors);
    }
    return true;
  } catch (error) {
    console.error(`❌ Failed to delete from S3:`, error);
    return false;
  }
};

export function CapitalizeEachWordForName(text: any) {
  if (!text) return "";
  return text
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

export function CapitalizeFirstWord(text: string): string {
  if (!text) return "";
  return text
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
